const $ = require('jquery');

class AnnouncerService {
    /* Announcer for screen-readers
       Based on the md-live-annoucer
       For accessiblity especially in IE11 + JAWS
       https://github.com/angular/material/blob/master/src/core/services/liveAnnouncer/live-announcer.js
    */

    constructor($timeout) {
        this.$timeout = $timeout;
        this.srElement = this.createScreenReaderElement();
    }

    announce(message) {
        // The timeout + clearing the message is necessary to trick screen readers into reading the message
        this.srElement.text('');

        this.$timeout(() => {
            this.srElement.text(message);
        }, 100, false);
    }

    createScreenReaderElement() {
        const srElement = $('<div class="sr-only" role="status" aria-atomic="true" aria-live="polite"></div>');
        $('body').append(srElement);
        return srElement;
    }
}

AnnouncerService.$inject = ['$timeout'];

module.exports = AnnouncerService;



// WEBPACK FOOTER //
// ./src/olycommon/accessibility/announcer.service.js